import { useReducer } from 'react'

import {
  type UseControls,
  type UseControlsActions,
  UseControlsActionTypes,
  type UseControlsReducerState,
} from '../types'

const initialState: UseControlsReducerState = {
  isPagesAndBlocks: true,
  isSeoMetaTags: true,
  isWireframeTypes: true,
  isBlocksContents: true,
  isSections: true,
  isNotes: true,
}

const reducer = (
  state: UseControlsReducerState,
  action: UseControlsActions
): UseControlsReducerState => {
  switch (action.type) {
    case UseControlsActionTypes.SET_PAGES_BLOCKS:
      return {
        ...state,
        isPagesAndBlocks: !state.isPagesAndBlocks,
      }

    case UseControlsActionTypes.SET_WIREFRAMES:
      return {
        ...state,
        isWireframeTypes: !state.isWireframeTypes,
      }

    case UseControlsActionTypes.SET_SEO_META:
      return {
        ...state,
        isSeoMetaTags: !state.isSeoMetaTags,
      }

    case UseControlsActionTypes.SET_BLOCKS_CONTENTS:
      return {
        ...state,
        isBlocksContents: !state.isBlocksContents,
      }

    case UseControlsActionTypes.SET_SECTIONS:
      return {
        ...state,
        isSections: !state.isSections,
      }

    case UseControlsActionTypes.SET_NOTES:
      return {
        ...state,
        isNotes: !state.isNotes,
      }

    default:
      return state
  }
}

const useControls = (): UseControls => {
  const [state, dispatch] = useReducer(reducer, { ...initialState })

  return {
    state,
    actions: {
      setPagesBlocks: () =>
        dispatch({ type: UseControlsActionTypes.SET_PAGES_BLOCKS }),
      setWireframes: () =>
        dispatch({ type: UseControlsActionTypes.SET_WIREFRAMES }),
      setSeoMeta: () => dispatch({ type: UseControlsActionTypes.SET_SEO_META }),
      setBlocksContents: () =>
        dispatch({ type: UseControlsActionTypes.SET_BLOCKS_CONTENTS }),
      setSections: () =>
        dispatch({ type: UseControlsActionTypes.SET_SECTIONS }),
      setNotes: () => dispatch({ type: UseControlsActionTypes.SET_NOTES }),
    },
  }
}

export default useControls
